export default "__VITE_ASSET__EycYD4MKA2_RHOkh0yIivA__"